import { TextInput } from './TextInput';

export type { TypeTextInputProps } from './types';
export default TextInput;
